import { Label, SearchableSelect } from '@shared/components';

export const INVOICING_DEALER_GATED_NOTE = 'You do not have permission to see the dealers you can invoice for.';

interface Props<TOption> {
    id: string;
    options: TOption[];
    value: TOption | null;
    onChange: (next: TOption | null) => void;
    getOptionValue: (option: TOption) => string;
    getOptionLabel: (option: TOption) => string;
    loading?: boolean;
    disabled?: boolean;
    emptyLabel: string;
    error?: string;
    note?: string | null;
}

export function InvoicingDealerField<TOption>({
    id,
    options,
    value,
    onChange,
    getOptionValue,
    getOptionLabel,
    loading = false,
    disabled = false,
    emptyLabel,
    error,
    note = null,
}: Props<TOption>) {
    const errorId = `${id}-error`;

    return (
        <div>
            <Label htmlFor={id} required>
                Invoicing dealer
            </Label>
            <SearchableSelect<TOption>
                id={id}
                options={options}
                value={value}
                onChange={onChange}
                getOptionValue={getOptionValue}
                getOptionLabel={getOptionLabel}
                loading={loading}
                disabled={disabled}
                placeholder="Search dealers..."
                emptyLabel={emptyLabel}
                aria-invalid={!!error}
                aria-describedby={error ? errorId : undefined}
            />
            {error && (
                <p id={errorId} className="mt-1.5 text-xs text-mp-error">
                    {error}
                </p>
            )}
            {note && <p className="mt-1.5 text-xs text-mp-muted">{note}</p>}
        </div>
    );
}
